interface Item {
  sku: string
  quantity: number
}

export interface ValidationResult {
  isValid: boolean
  warning: string | null
  messageParts?: {
    beforeLink: string
    linkText: string
    afterLink: string
  }
}

export const validateWoodenTableRequirements = (
  items: Item[]
): ValidationResult => {
  const woodenTableQuantity = items
    .filter(item => item.sku === 'WOODEN TABLE')
    .reduce((sum, item) => sum + item.quantity, 0)

  if (woodenTableQuantity === 0) {
    return { isValid: true, warning: null }
  }

  const berQuantity = items
    .filter(item => item.sku.includes('-BER'))
    .reduce((sum, item) => sum + item.quantity, 0)

  if (berQuantity === 0) {
    return {
      isValid: false,
      warning:
        'The wooden table cannot be sold separately; it must be sold as a bundle with the Base Easy Reach (BER33 or BER36).',
      messageParts: {
        beforeLink:
          'The wooden table cannot be sold separately; it must be sold as a bundle with the Base Easy Reach (',
        linkText: 'BER33 or BER36',
        afterLink: ').'
      }
    }
  }

  if (berQuantity < woodenTableQuantity) {
    return {
      isValid: false,
      warning: `Each wooden table requires at least one Base Easy Reach (BER). You have ${woodenTableQuantity} wooden table(s) but only ${berQuantity} BER item(s). Please add ${
        woodenTableQuantity - berQuantity
      } more BER item(s) to your cart.`,
      messageParts: {
        beforeLink: 'Each wooden table requires at least one Base Easy Reach (',
        linkText: 'BER',
        afterLink: `). You have ${woodenTableQuantity} wooden table(s) but only ${berQuantity} BER item(s). Please add ${
          woodenTableQuantity - berQuantity
        } more BER item(s) to your cart.`
      }
    }
  }

  return { isValid: true, warning: null }
}
